import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, Inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AssociationListResponse } from '@services/back-office/model/associationListResponse';
import { AssociationsService } from '@shared/services/associations.service';
import { SharedService } from '@shared/shared.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, catchError, EMPTY, Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {OrganizationTariffModel} from "@services/back-office/model/organizationTariffModel";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-association-tariff-dialog',
    templateUrl: './association-tariff-dialog.component.html',
    styleUrls: ['./association-tariff-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AssociationTariffDialogComponent implements OnInit, OnDestroy {
  /** Subject to destroy Subscriptions */
  private destroyed$ = new Subject<void>();
  /** Loading */
  loading$ = new BehaviorSubject(false);
  /** Form */
  tariffForm: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      association: AssociationListResponse
    },
    public dialogRef: MatDialogRef<AssociationTariffDialogComponent>,
    private associationsService: AssociationsService,
    private formBuilder: UntypedFormBuilder,
    private translateService: TranslateService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.tariffForm = this.formBuilder.group({
      startDate: [{value: new Date(), disabled: true}, [Validators.required]],
      tariff: [this.data.association.tariff, [Validators.required]],
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.loading$.complete();
  }

  submitForm() {
    const formData = this.tariffForm.getRawValue();
    this.loading$.next(true);

    this.associationsService.addTariff(this.data.association.id, formData.tariff).pipe(
        take(1),
        map((response: OrganizationTariffModel) => {
          this.loading$.next(false);
          this.closeDialog(true, response);
        }),
        catchError((error: HttpErrorResponse) => {
          SharedService.showErrorWithTitle(
              this.translateService,
              this.toastrService,
              `responseErrors.${error.error.message}`
          );
          this.loading$.next(false);
          return EMPTY;
        })
    ).subscribe();

  }

  /** Close dialog */
  closeDialog(result: boolean, data?: any) {
    this.dialogRef.close({result, data});
  }

}
